import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';

import { ErrorAlertIllustration } from './components/Illustration';
import Button, { BUTTON_STYLE } from '../../../shared-components/Button/Button';
import { DOCUMENTS_REQUIRED } from './constants/slides';
import { updateRetryCount } from './FinalSubmitErrorPageAction';
import { REDIRECT_SUFFIX } from '../../config/pageNames';
import { redirectFlowAction } from '../../../framework/store/RedirectFlow/RedirectFlowActions';
import { CaptionText } from './components/CaptionText';
import { trackTransition } from '../../../framework/store/FPTI/FPTIActions';

import './FinalSubmitErrorPage.less';

const LOCALE_PREFIX = 'US/pages/AppPendPage/ErrorPage';

export class FinalSubmitErrorPage extends Component {
    static propTypes = {
        navigate: PropTypes.func.isRequired,
        finalSubmitRetryCount: PropTypes.number.isRequired,
        updateUvsRetryCount: PropTypes.func.isRequired,
        cancelRedirect: PropTypes.func.isRequired,
        onComponentDidMount: PropTypes.func.isRequired
    };

    static defaultProps = {
        onComponentDidMount: () => {}
    };

    componentDidMount() {
        this.props.onComponentDidMount();
    }

    onRetryClick = () => {
        const { navigate, finalSubmitRetryCount, updateUvsRetryCount } = this.props;
        updateUvsRetryCount(finalSubmitRetryCount + 1);
        navigate(DOCUMENTS_REQUIRED);
    };

    onCancelClick = () => {
        this.props.cancelRedirect(REDIRECT_SUFFIX.CANCEL_REDIRECT);
    };

    retryButton = () => (
        <>
            <CaptionText className="errorPagePrimarytext" text={`${LOCALE_PREFIX}.RETRY-WENT_WRONG-TEXT`} />
            <Button className="errorPageActionButton"
                data-automation-id="redirect"
                btnStyle={BUTTON_STYLE.LINK}
                onClick={this.onRetryClick}
            >
                <FormattedMessage id={`${LOCALE_PREFIX}.RETRY-BTN-TEXT`} />
            </Button>
        </>
    );

    errorMessage = () => (
        <>
            <CaptionText className="errorPagePrimarytext" text={`${LOCALE_PREFIX}.RETRY-UNAVAILABLE-TEXT`} />
            <CaptionText className="errorPageSubtext" text={`${LOCALE_PREFIX}.RETRY-UNAVAILABLE-SUB-TEXT`} />
        </>
    );

    render() {
        const { finalSubmitRetryCount } = this.props;
        return (
            <div className="errorPageContainer">
                <a data-automation-id="close-popup" onClick={this.onCancelClick} href="javascript:void(0)" className="cue-close-icon pull-icon-right">Close popup</a>
                <div className="errorPageIcon"><ErrorAlertIllustration /></div>
                {finalSubmitRetryCount < 2 ? this.retryButton() : this.errorMessage()}
            </div>
        );
    }
}

export const mapStateToProps = state => ({
    finalSubmitRetryCount: get(state, 'serverData.appPendData.finalSubmitRetryCount', 0),
});

export const mapDispatchToProps = dispatch => ({
    onComponentDidMount() {
        dispatch(trackTransition('apply_pp_credit_finalSubmitErrorPage', 'prepare_pp_credit_finalSubmitErrorPage'));
    },
    updateUvsRetryCount(count) {
        dispatch(trackTransition('apply_pp_credit_finalSubmitErrorPage', 'tryAgain_pp_credit_finalSubmitErrorPage'));
        return dispatch(updateRetryCount(count));
    },
    cancelRedirect(actionUri) {
        dispatch(trackTransition('apply_pp_credit_finalSubmitErrorPage', 'cancel_pp_credit_finalSubmitErrorPage'));
        dispatch(redirectFlowAction(actionUri));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(FinalSubmitErrorPage);
